interface ISubmitApplicationResponse {
    applicationId: string
    dno: string
}

export const isSubmitApplicationResponse = (
    obj: unknown
): obj is ISubmitApplicationResponse =>
    typeof obj === "object" &&
    obj !== null &&
    "applicationId" in obj &&
    "dno" in obj &&
    typeof obj?.applicationId === "string" &&
    typeof obj?.dno === "string"
